import { render } from "./SkeletonHeader.vue?vue&type=template&id=2527e060"
import script from "./SkeletonHeader.vue?vue&type=script&lang=js"
export * from "./SkeletonHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__